<div (click)="goToAbout()">
  About this website
</div>
